//
// Copyright (c) 2019-Present Syncari - All rights reserved.
//
import cx from 'classnames';
import { ReactNode } from 'react';

import './FormFooter.less';

export interface FormFooterProps {
  left?: ReactNode;
  right: ReactNode;
  className?: string;
}

export const FormFooter = ({ left, right, className }: FormFooterProps) => {
  return (
    <div className={cx('synri-form-footer', className)}>
      <div className="synri-form-footer__left">{left}</div>
      <div className="synri-form-footer__right">{right}</div>
    </div>
  );
};
